const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/merge-dev/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/(app)/org/$org/merge-dev/')({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});
type Account = {
  id: string;
  category: string | null;
  integrationName: string | null;
  mergeAccountId: string | null;
  createdAt: string;
};